import { render, staticRenderFns } from "./mixin_formSubmissionProcess.vue?vue&type=template&id=2fd19a95&scoped=true"
import script from "./mixin_formSubmissionProcess.vue?vue&type=script&lang=js"
export * from "./mixin_formSubmissionProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd19a95",
  null
  
)

export default component.exports